import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { getButtonLoadingStyles } from "../styled/getButtonLoadingStyles";
import { ursaPadding } from "../styled/getButtonPadding";
var getMargin = function getMargin(hasLeftIcon, hasRightIcon, appearance, size) {
  switch (appearance) {
    // For Lodestar buttons.
    case "borderless":
    case "primary":
    case "secondary":
    case "destructive":
    case "destructive-tertiary":
    case "secondary-destructive":
    case "share":
      // Icons already provide a margin, so the content is only responsible for edges without an icon
      if (hasLeftIcon && hasRightIcon) {
        return {
          margin: "0"
        };
      }
      if (hasLeftIcon) {
        return {
          marginRight: "".concat(sizes.small - 1, "px")
        }; // -1px for border
      }

      if (hasRightIcon) {
        return {
          marginLeft: "".concat(sizes.small - 1, "px")
        };
      }
      // Proper spacing will be provided by the button padding if there are no icons present
      return {
        margin: "0"
      };

    // For Ursa buttons.
    case "primary-filled":
    case "primary-empty":
    case "secondary-filled":
    case "secondary-outlined":
    case "secondary-empty":
    case "canvas-filled":
    case "canvas-empty":
    case "destructive-filled":
    case "destructive-empty":
      // Icons already provide a margin, so the content is only responsible for edges without an icon
      if (hasLeftIcon && hasRightIcon) {
        return {
          margin: "0 1px"
        };
      }
      if (hasLeftIcon) {
        // -1px for border, opposite side +1px to account for the -1 on the icon
        return {
          marginRight: "calc(".concat(ursaPadding[size], " - 1px)"),
          marginLeft: "1px"
        };
      }
      if (hasRightIcon) {
        return {
          marginLeft: "calc(".concat(ursaPadding[size], " - 1px)"),
          marginRight: "1px"
        };
      }
      // Proper spacing will be provided by the button padding if there are no icons present
      return {
        margin: "0"
      };
  }
};
export var Content = styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    ", "\n    ", "\n"])), function (_ref) {
  var isLoading = _ref.isLoading;
  return getButtonLoadingStyles(isLoading);
}, function (_ref2) {
  var hasLeftIcon = _ref2.hasLeftIcon,
    hasRightIcon = _ref2.hasRightIcon,
    appearance = _ref2.appearance,
    size = _ref2.size;
  return getMargin(hasLeftIcon, hasRightIcon, appearance, size);
});
//# sourceMappingURL=Content.js.map